// extracted by mini-css-extract-plugin
export var deliveryRow = "_n6-a";
export var fixedHeight = "_n6-4";
export var freightLogo = "_n6-9";
export var fullWidth = "_n6-3";
export var priceColumn = "_n6-5";
export var radioSelected = "_n6-7";
export var radioUnselected = "_n6-6";
export var selectedOption = "_n6-2";
export var selectedOptionContainer = "_n6-1";
export var selection = "_n6-0";
export var tallSkeletonText = "_n6-8";